import React, { Fragment, useState, useEffect } from 'react';
import { Field } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import GraphQL from '../../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../../shared/components/ShowNotification';
import SelectVirtualized from '../../../../shared/components/form/SelectVirtualized';
import { relationObjectListByParamsQuery } from '../../../../shared/queries/RelationObject';
import renderField from '../../../../shared/components/form/RenderField';

const SurveyFields = (props) => {
  const { t, showLoading, hideLoading, change, editable } = props;
  const [recipients, setRecipients] = useState([]);

  const loadRecipients = () => {
    showLoading();
    const query = relationObjectListByParamsQuery(true, false, true, true);
    GraphQL(query, {})
      .then((res) => {
        res.relationObjectListByParams = res.relationObjectListByParams.map(
          (item) => ({
            ...item,
            value: item.identifier,
            label: item.description,
          })
        );
        setRecipients(res.relationObjectListByParams);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const onRecipientChange = (values) => {
    if (values) {
      change('recipients', values);
    } else {
      change('recipients', []);
    }
  };

  useEffect(() => {
    loadRecipients();
  }, []);

  return (
    <Fragment>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.recipients')}
        </span>
        <div className="form_form-group-field">
          <Field
            name="recipients"
            isMulti
            closeMenuOnSelect={false}
            component={SelectVirtualized}
            options={recipients}
            disabled={!editable}
            onChange={onRecipientChange}
            placeholder={t('general.placeholders.select')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.title')}</span>
        <div className="form__form-group-field">
          <Field
            name="title"
            type="text"
            placeholder={t('communication.placeholders.survey-title')}
            component={renderField}
            maxLength="250"
            readOnly={!editable}
          />
        </div>
      </div>
    </Fragment>
  );
};

SurveyFields.propTypes = {
  t: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
};

export default withTranslation('common')(SurveyFields);
